export const EVENT_STATUS_CONFIG: Record<string, { label: string; colorPalette: string; color: string }> = {
  prospection: { label: 'Reservado', colorPalette: 'blue', color: '#3b82f6' },
  confirmed: { label: 'Confirmado', colorPalette: 'green', color: '#22c55e' },
  cancelled: { label: 'Cancelado', colorPalette: 'red', color: '#ef4444' },
  searched: { label: 'Procurado', colorPalette: 'gray', color: '#71717a' },
}
